import { clearInputField, } from '../../helpers';

const clearUnusedRadioDependantFields = ($form, $radioButtons, $field_selector) => {
  $radioButtons.each((_, element) => {
    if (element.value !== 'true') {
      $(`${$field_selector} input`, $form).each((_, inputElement) => {
        clearInputField(inputElement);
      });
    }
  });
};

$(() => {
  const $form = $('form#subscription-form');

  if ($form.length === 0) {
    return;
  }

  const $environmentalEnvestingRadioButtons = $('#environmental-investing-radio-buttons input[type=radio]', $form);
  const $environmentalInvestingFields = $('#environmental-investing-fields', $form);

  const $expectEnvironmentalInvestmentsRadioButtons = $('#expect-environmental-investments-radio-buttons', $form);
  const $expectEnvironmentalInvestmentsFields = $('#expect-environmental-investments-fields', $form);

  const $expectDisclosureRegulationInvestmentRadioButtons = $('#expect-disclosure-regulation-investment-radio-buttons', $form);
  const $expectDisclosureRegulationInvestmentFields = $('#expect-disclosure-regulation-investment-fields', $form);

  const $shouldConsiderNegativeExternalitiesRadioButtons = $('#should-consider-negative-externalities-radio-buttons', $form);
  const $shouldConsiderNegativeExternalitiesFields = $('#should-consider-negative-externalities-fields', $form);

  const $subscriptionConcerningExternalitiesOtherCheck = $('#subscription_concerning_externalities_other', $form);
  const $otherConcerningExternalityField = $('#other-concerning-externality-field', $form);

  const $subscriptionWaysToMitigateExternalitiesOther = $('#subscription_ways_to_mitigate_externalities_other', $form);
  const $otherWayToMitigateExternalitiesField = $('#other-way-to-mitigate-externalities-field', $form);

  $environmentalEnvestingRadioButtons.on('change', (e) => {
    if (e.target.value === 'true') {
      $environmentalInvestingFields.removeClass('d-none');
    } else {
      $environmentalInvestingFields.addClass('d-none');
      $expectEnvironmentalInvestmentsFields.addClass('d-none');
      $expectDisclosureRegulationInvestmentFields.addClass('d-none');
      clearUnusedRadioDependantFields($form, $environmentalEnvestingRadioButtons, '#environmental-investing-fields');
    }
  });

  $expectEnvironmentalInvestmentsRadioButtons.on('change', (e) => {
    if (e.target.value === 'true') {
      $expectEnvironmentalInvestmentsFields.removeClass('d-none');
    } else {
      $expectEnvironmentalInvestmentsFields.addClass('d-none');
      $expectDisclosureRegulationInvestmentFields.addClass('d-none');
      $shouldConsiderNegativeExternalitiesFields.addClass('d-none');
      $otherConcerningExternalityField.addClass('d-none');
      $otherWayToMitigateExternalitiesField.addClass('d-none');
      clearUnusedRadioDependantFields($form, $expectEnvironmentalInvestmentsRadioButtons, '#expect-environmental-investments-fields');
    }
  });

  $expectDisclosureRegulationInvestmentRadioButtons.on('change', (e) => {
    if (e.target.value === 'true') {
      $expectDisclosureRegulationInvestmentFields.removeClass('d-none');
    } else {
      $expectDisclosureRegulationInvestmentFields.addClass('d-none');
      $shouldConsiderNegativeExternalitiesFields.addClass('d-none');
      $otherConcerningExternalityField.addClass('d-none');
      $otherWayToMitigateExternalitiesField.addClass('d-none');
      clearUnusedRadioDependantFields($form, $expectDisclosureRegulationInvestmentRadioButtons, '#expect-disclosure-regulation-investment-fields');
    }
  });

  $shouldConsiderNegativeExternalitiesRadioButtons.on('change', (e) => {
    if (e.target.value === 'true') {
      $shouldConsiderNegativeExternalitiesFields.removeClass('d-none');
    } else {
      $shouldConsiderNegativeExternalitiesFields.addClass('d-none');
      $otherConcerningExternalityField.addClass('d-none');
      $otherWayToMitigateExternalitiesField.addClass('d-none');
      clearUnusedRadioDependantFields($form, $shouldConsiderNegativeExternalitiesRadioButtons, '#should-consider-negative-externalities-fields');
    }
  });

  $subscriptionConcerningExternalitiesOtherCheck.on('change', (e) => {
    if (e.target.checked === true) {
      $otherConcerningExternalityField.removeClass('d-none');
    } else {
      $otherConcerningExternalityField.addClass('d-none');
      $('input', $otherConcerningExternalityField).each((_, inputElement) => {
        clearInputField(inputElement);
      });
    }
  });

  $subscriptionWaysToMitigateExternalitiesOther.on('change', (e) => {
    if (e.target.checked === true) {
      $otherWayToMitigateExternalitiesField.removeClass('d-none');
    } else {
      $otherWayToMitigateExternalitiesField.addClass('d-none');
      $('input', $otherWayToMitigateExternalitiesField).each((_, inputElement) => {
        clearInputField(inputElement);
      });
    }
  });
});
